<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex xs12>
        <v-stepper :value="quoteLifeCycle" class="quoteLifeCycle">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="quoteLifeCycle > 1">Quotation Summary</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="quoteLifeCycle > 2">Premium</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- The following dialog will work with leaveQuote Mixin (individual module to follow this structure:: just change the title) -->
        <promptLeave title="Cargo" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
      </v-flex>
      <v-flex lg4 xs12 order-lg2 order-xs1>
        <quick-info></quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Cargo Quotation Details..." errorText="Failed to load Cargo Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import PromptLeave from '../../shared/leaveQuote/PromptLeave'
import { leaveQuote } from '../../shared/leaveQuote'
import QuickInfo from '../query/QuickInfo'

export default {
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quoteLifeCycle() {
      return this.$store.state.agency.quotation.quoteLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('cargoQuoteInit')
    }
  },
  mounted() {
    // Set query mode on lifeCycle component (to disable editing of sales oppo)
    this.toggleQuery(true)

    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave,
    QuickInfo
  },
  mixins: [
    leaveQuote
  ],
  props: {
    toggleQuery: {
      type: Function,
      default: function (queryMode) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../assets/scss/base.scss";
</style>
